
const AdminFooter = () => {

    const currrentTime = new Date();
    const currentYear = currrentTime.getFullYear()
    return (
        <>
            <footer className="sticky-footer bg-white">
                <div className="container my-auto">
                    <div className="copyright text-center my-auto">
                        <span>{" "}
                            &copy; {currentYear} Used Cars – Popular Maruti. All rights reserved. Digitally Empowered by <a href="https://netventure.in/" target="_blank" rel="noopener noreferrer" style={{color: 'inherit'}}>NetVenture</a>
</span>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default AdminFooter;